import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import GlobalStyles from "@mui/material/GlobalStyles";
import { useSelector } from "react-redux";

import { MainNav } from "../../components/dashboard/layout/main-nav";
import { SideNav } from "../../components/dashboard/layout/side-nav";
import CustomerPlanSync from "../../components/dashboard/layout/CustomerPlanSync";
// Remove AdminSubNav import for customer layout

export default function Layout({ children }) {
  const modules = useSelector((s) => s.auth.modules);
  // No plan yet = no module with any permission: only the plan page, no sidebar and no top navigation
  const noPlan = !(modules || []).some((m) => (m.permissions || []).length > 0);
  return (
    <div>
      <CustomerPlanSync />
      <GlobalStyles
        styles={{
          body: {
            "--MainNav-height": "64px",
            "--MainNav-zIndex": 1000,
            "--SideNav-width": "250px",
            "--SideNav-zIndex": 1100,
            "--MobileNav-width": "320px",
            "--MobileNav-zIndex": 1100,
          },
        }}
      />
      <Box
        sx={{
          bgcolor: "var(--mui-palette-background-default)",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          minHeight: "100%",
        }}
      >
        {/* SideNav is full-height, fixed to the left edge from the very top
            of the page. MainNav sits in the content column beside it, so
            its left edge touches the sidebar's right border instead of
            spanning the full page width above it. */}
        <Box sx={{ display: "flex", flex: "1 1 auto" }}>
          {!noPlan && <SideNav />}
          <Box
            sx={{
              display: "flex",
              flex: "1 1 auto",
              flexDirection: "column",
              pl: noPlan ? 0 : { lg: "var(--SideNav-width)" },
              // Room for the docked AI chat panel (set by ChatBot.jsx, 0 when it is not docked).
              pr: { md: "var(--ChatDock-width, 0px)" },
              transition: "padding-right 0.2s ease",
            }}
          >
            {!noPlan && <MainNav />}
            {/* AdminSubNav is removed from customer layout */}
            <main>
              {/* maxWidth={false} — a fixed "xl" cap left a big empty gap,
                  symmetric on both sides, once the sidebar collapses and
                  frees up more width than the cap allows for; this way the
                  content always fills whatever space the sidebar leaves. */}
              <Container maxWidth={false} sx={{ py: { xs: "24px", sm: "40px", md: "64px" }, px: { xs: 1.5, sm: 3 } }}>
                {children}
              </Container>
            </main>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
